import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LayoutComponent } from '../components/layout/layout.component';
import { RoutesComponent } from '../buses/routes/routes.component';
import { BusStudentsComponent } from './bus-students/bus-students.component';
import { BusTrackingComponent } from './bus-tracking/bus-tracking.component';
import { SubscriptionRequestsComponent } from './subscription-requests/subscription-requests.component';
import { EnrollErrorsComponent } from './enroll-students-buses-system/enroll-errors/enroll-errors.component';
import { EnrollDetailsComponent } from './enroll-students-buses-system/enroll-details/enroll-details.component';
import { UploadEnrollFileComponent } from './bulk-enroll/bulk-enroll-steps/upload-enroll-file/upload-enroll-file.component';
import { AssignTripsComponent } from './bulk-enroll/bulk-enroll-steps/assign-trips/assign-trips.component';
import { EnrollColumnMappingComponent } from './bulk-enroll/bulk-enroll-steps/enroll-column-mapping/enroll-column-mapping.component';
import { EnrollFixErrorsComponent } from './bulk-enroll/bulk-enroll-steps/enroll-fix-errors/enroll-fix-errors.component';
import { AssignTripsCanDeactivateGuard } from './bulk-enroll/bulk-enroll-steps/assign-trips/assign-trips-can-deactivate.guard';

const routes: Routes = [
    {
        path: '', component: LayoutComponent,
        children: [
            // {
            //     path: 'routes',
            //     component: RoutesComponent
            // },
            {
                path: 'students',
                component: BusStudentsComponent
            },
            {
                path: 'bus-requestes',
                component: SubscriptionRequestsComponent
            },
            {
                path: 'enroll-errors',
                component: EnrollErrorsComponent
            },
            {
                path: 'enroll-details',
                component: EnrollDetailsComponent
            },
            {
                path: 'bulk-enroll/upload-file',
                component: UploadEnrollFileComponent
            },
            {
                path: 'bulk-enroll/column-mapping',
                component: EnrollColumnMappingComponent
            },
            {
                path: 'bulk-enroll/fix-errors',
                component: EnrollFixErrorsComponent
            },
            {
                path: 'bulk-enroll/assign-trips',
                component: AssignTripsComponent,
                canDeactivate: [AssignTripsCanDeactivateGuard]
            },
            // {
            //     path: 'tracking',
            //     component: BusTrackingComponent
            // },
            {
                path: '',
                redirectTo: '/buses/students',
                pathMatch: 'full'
            }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class BusesRoutingModule { }